module.exports = __webpack_public_path__ + "img/symbol_13_x12.37368967.png";